<div class="grid-row">
	<div class="column">
		<app-navigation-header i18n-title="The Dashboard|Dashboard for home screen@@Dashboard" title="Dashboard">
			<app-cards
				i18n-title="Devices Alerts|LowBattery and Missing Key tile@@device_alert_list"
				title="Device Alerts"
				class="device-alert"
			>
				<div class="device-alert-main-tab-container">
					<app-device-alerts-main-tab data-automation-id="device-alerts-tab"></app-device-alerts-main-tab>
				</div>
			</app-cards>
		</app-navigation-header>
	</div>
	<div class="column device-map">
		<!-- i18n-title="Device Map tile@@device_alert_list" -->
		<app-cards i18n-title="@@home-deviceMap" title="Device Map">
			<div class="device-map-header">
				<div class="device-map-title-container">
					<span class="p-bold" data-automation-id="home-deviceMap" i18n="@@home-deviceMap">Device Map</span>
					<span class="p-small" i18n="@@home-summaryOfDailyAccesses">Summary of daily accesses</span>
				</div>
				<button mat-icon-button [matMenuTriggerFor]="menu" data-automation-id="menu-summary-button">
					<mat-icon>more_vert</mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="refreshDeviceMap()" data-automation-id="refresh-device-button">
						<!-- <mat-icon >refresh</mat-icon> -->
						<span i18n="@@home-matMenu-refresh">Refresh</span>
					</button>
				</mat-menu>
			</div>
			<app-device-map-home></app-device-map-home>
		</app-cards>

		<div class="device-notes">
			<app-cards i18n-title="@@home-deviceNotes" title="Device Notes">
				<app-device-notes-home></app-device-notes-home>
			</app-cards>
		</div>
	</div>
</div>

<!-- <app-cards i18n-title="Pending Lockbox Installations|Tile of pending installations@@pending_installations"
  title="Pending Lockbox Installations">

</app-cards>

<app-cards i18n-title="Settings tile@@settings_tile_home" title="Settings">
  <div i18n="PlaceholderText@@PlaceholdeText_mini_card_content">Mini Card Content Here</div>
</app-cards> -->
